import { SelectionBox } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding: 5.6rem 4rem 4.15rem;
  text-align: center;
  align-items: center;
  height: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 3.2rem 1.6rem;
    gap: 1.6rem;
  }
`;

export const StyledContentContainer = styled.div`
  width: 51.7rem;
  height: 100%;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.title};
  }
`;

export const StyledSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledSelectionBox = styled(SelectionBox)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    gap: 1.6rem;
  }
`;
